/* Header Mamorigatana — recherche inline + panneau dropdown */
(function () {
  'use strict';

  var eventsBound = false;

  function getEls() {
    return {
      header: document.querySelector('[data-mrg-header]'),
      burger: document.getElementById('mrg-burger-toggle'),
      mobileNav: document.getElementById('mrg-mobile-nav'),
      searchWrap: document.getElementById('mrg-header-search'),
      searchTrigger: document.getElementById('mrg-search-trigger'),
      searchToggle: document.getElementById('mrg-search-toggle'),
      searchInput: document.getElementById('MrgHeaderSearchInput'),
      searchDropdown: document.getElementById('mrg-search-dropdown'),
      searchMobileToggle: document.getElementById('mrg-search-mobile-toggle'),
      accountWrap: document.getElementById('mrg-header-account'),
      accountToggle: document.getElementById('mrg-account-toggle'),
      accountMenu: document.getElementById('mrg-account-menu'),
    };
  }

  function closeMobileNav(els) {
    if (!els.mobileNav || els.mobileNav.hidden) return;
    els.mobileNav.hidden = true;
    if (els.burger) els.burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mrg-nav-open');
  }

  function openMobileNav(els) {
    closeSearch(els);
    closeAccount(els);
    els.mobileNav.hidden = false;
    if (els.burger) els.burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mrg-nav-open');
  }

  function closeAccount(els) {
    if (!els.header || !els.accountWrap || !els.header.classList.contains('is-account-open')) return;

    els.header.classList.remove('is-account-open');
    if (els.accountToggle) {
      els.accountToggle.setAttribute('aria-expanded', 'false');
      els.accountToggle.setAttribute('aria-label', 'Ouvrir le menu compte');
    }
    if (els.accountMenu) {
      els.accountMenu.setAttribute('aria-hidden', 'true');
    }
  }

  function openAccount(els) {
    if (!els.header || !els.accountWrap || els.header.classList.contains('is-account-open')) return;

    closeSearch(els);
    closeMobileNav(els);

    els.header.classList.add('is-account-open');
    if (els.accountToggle) {
      els.accountToggle.setAttribute('aria-expanded', 'true');
      els.accountToggle.setAttribute('aria-label', 'Fermer le menu compte');
    }
    if (els.accountMenu) {
      els.accountMenu.setAttribute('aria-hidden', 'false');
    }
  }

  function closeSearch(els) {
    if (!els.searchWrap || !els.searchWrap.classList.contains('is-open')) return;

    els.searchWrap.classList.remove('is-open');
    if (els.header) els.header.classList.remove('is-search-open');

    if (els.searchTrigger) {
      els.searchTrigger.setAttribute('aria-expanded', 'false');
    }
    if (els.searchToggle) {
      els.searchToggle.setAttribute('aria-label', 'Ouvrir la recherche');
    }
    if (els.searchDropdown) {
      els.searchDropdown.setAttribute('aria-hidden', 'true');
    }
    if (els.searchInput) {
      els.searchInput.value = '';
      els.searchInput.blur();
    }
  }

  function openSearch(els) {
    if (!els.searchWrap || !els.header || els.searchWrap.classList.contains('is-open')) return;

    closeAccount(els);
    closeMobileNav(els);

    els.searchWrap.classList.add('is-open');
    els.header.classList.add('is-search-open');

    if (els.searchTrigger) {
      els.searchTrigger.setAttribute('aria-expanded', 'true');
    }
    if (els.searchToggle) {
      els.searchToggle.setAttribute('aria-label', 'Fermer la recherche');
    }
    if (els.searchDropdown) {
      els.searchDropdown.setAttribute('aria-hidden', 'false');
    }

    window.requestAnimationFrame(function () {
      if (els.searchInput) els.searchInput.focus();
    });
  }

  function bindSearchToggle(els) {
    if (!els.searchToggle || els.searchToggle.dataset.mrgBound === 'true') return;
    els.searchToggle.dataset.mrgBound = 'true';

    els.searchToggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      var current = getEls();
      if (!current.searchWrap) return;

      if (current.searchWrap.classList.contains('is-open')) closeSearch(current);
      else openSearch(current);
    });
  }

  function bindEvents() {
    if (eventsBound) return;
    eventsBound = true;

    bindSearchToggle(getEls());

    document.addEventListener('click', function (event) {
      var els = getEls();
      if (!els.searchWrap) return;

      if (event.target.closest('#mrg-search-trigger')) {
        event.preventDefault();
        openSearch(els);
        return;
      }

      if (event.target.closest('#mrg-account-toggle')) {
        event.preventDefault();
        event.stopPropagation();
        if (els.header && els.header.classList.contains('is-account-open')) closeAccount(els);
        else openAccount(els);
        return;
      }

      if (event.target.closest('#mrg-search-toggle')) {
        return;
      }

      if (
        els.searchWrap.classList.contains('is-open') &&
        !event.target.closest('#mrg-header-search') &&
        !event.target.closest('#mrg-search-dropdown')
      ) {
        closeSearch(els);
        return;
      }

      if (
        els.header &&
        els.header.classList.contains('is-account-open') &&
        !event.target.closest('#mrg-header-account')
      ) {
        closeAccount(els);
        return;
      }

      if (event.target.closest('#mrg-search-mobile-toggle') && els.mobileNav) {
        openMobileNav(els);
        window.requestAnimationFrame(function () {
          var mobileSearch = els.mobileNav.querySelector('input[type="search"], input[type="text"]');
          if (mobileSearch) mobileSearch.focus();
        });
        return;
      }

      if (event.target.closest('#mrg-burger-toggle') && els.mobileNav) {
        if (els.mobileNav.hidden) openMobileNav(els);
        else closeMobileNav(els);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        var els = getEls();
        closeSearch(els);
        closeAccount(els);
        closeMobileNav(els);
      }
    });

    window.addEventListener('resize', function () {
      var els = getEls();
      if (window.innerWidth >= 990) closeMobileNav(els);
      if (window.innerWidth < 990) closeSearch(els);
      if (window.innerWidth < 990) closeAccount(els);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindEvents);
  } else {
    bindEvents();
  }
})();
